const progressSteps = document.querySelectorAll(".progress__step")

const handleProgress = (direction, step) => {

  if (direction === "next") {
    let prev = step - 1;
    progressSteps[prev - 1]?.classList.remove("is-active")
    progressSteps[prev - 1]?.classList.add("is-complete")
    progressSteps[step - 1]?.classList.add("is-active")
  }

  if (direction === "back") {
    let prev = step + 1;
    progressSteps[step - 1]?.classList.add("is-active")
    progressSteps[step - 1]?.classList.remove("is-complete")
    progressSteps[prev - 1]?.classList.remove("is-active")
  }

}

export default handleProgress